import React from 'react';
import { Link, withRouter } from 'react-router-dom';

import config from '@dom/config';

const animateHashLinkedElm = (elmId) => {
  const section = document.getElementById(elmId);

  // Add Fade animation to highlight elm in page after window scrolls to # link.
  section.animate([
    { opacity: 0.25 },
    { opacity: 1 },
    { opacity: 0.25 },
    { opacity: 1 },
  ], { 
    duration: 3000,
    iterations: 1
  });
};

function GuidePopularSearches(props) {
  return (
    <div className="place__name">
      <ul className="place__name_list">
        <li>
          <Link to="/list?baseCity=lukla">
            <div>Guides For Everest Region.</div>
          </Link>
        </li>
        <li>
          <Link to="/list?baseCity=pokhara">
            <div>Guides For Annapurna Region.</div>
          </Link>
        </li>
        <li>
          <a href="#no-specific-dates" onClick={() => animateHashLinkedElm("no-specific-dates")}>
            <div>I don’t know the Specific date and Region.</div>
          </a>
        </li>
        <li>
          <a href="#talk-to-a-guide" onClick={() => animateHashLinkedElm("talk-to-a-guide")}>
            <div>I want to talk to a specific guide first.</div>
          </a>
        </li>
        <li>
          If you have any query, Contact HoneyGuide on &nbsp;<a target="_blank" href={`https://wa.me/${config.honeyguidePhoneNumber}`} rel="noopener noreferrer nofollow"> Whatsapp</a> &nbsp; or &nbsp; <a target="_blank" href={`mailto:${config.honeyguideEmail}`} rel="noopener noreferrer nofollow">Email</a>
        </li>
      </ul>
    </div>
  );
}

export default withRouter(GuidePopularSearches);
